import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import {
  createCompanyEcommerceHash,
  deleteCompanyEcommerceHash,
  getCompanyEcommerceHashList,
  restoreCompanyEcommerceHash,
  updateCompanyEcommerceHash,
} from "../../services/CompanyEcommerceHashService";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { getCommonSearchList } from "../../services/settingsServices";

const PriceTypeList = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
];

const recordList = [
  { value: 0, label: "All" },
  { value: 1, label: "Delete record" },
];

const CompanyEcommerceHash = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const location = useLocation();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    record_show_type: 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [partGroupList, setPartGroupList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [partGroupData, setPartGroupData] = useState({
    id: "",
    ecommerce_name: "",
    token: "",
    allow_reserve: "",
    allow_sales: "",
    allow_refund: "",
    price_value: "",
    percentage: "",
    percentage_type: "",
  });

  let errorsObj = {
    ecommerce_name: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [percentageTypeList, setPercentageTypeList] = useState([]);

  const handleCheckboxChangeAllowReserve = (e) => {
    setPartGroupData({
      ...partGroupData,
      allow_reserve: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeAllowSales = (e) => {
    setPartGroupData({
      ...partGroupData,
      allow_sales: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeAllowRefund = (e) => {
    setPartGroupData({
      ...partGroupData,
      allow_refund: e.target.checked ? 1 : 0,
    });
  };

  const handleAddModal = () => {
    setModifyModal(true);
    setPartGroupData("");
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setPartGroupData({
      id: "",
      ecommerce_name: "",
      token: "",
      allow_reserve: "",
      allow_sales: "",
      allow_refund: "",
      price_value: "",
      percentage: "",
      percentage_type: "",
    });
    setErrors("");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "percentage_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPercentageTypeList(list);
      })
      .catch((err) => {});
  }, []);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value); // Save search to localStorage
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    } else if (type === "record_show_type") {
      const status = parseInt(e.target.value);
      paramsObj.record_show_type = status;
    }
    setParams(paramsObj);
  };

  const fetchPartLocation = () => {
    let data = { ...params };
    getCompanyEcommerceHashList(data)
      .then((response) => {
        setPartGroupList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };
      fetchPartLocation(data);
    },
    [params]
  );

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onEditPartType = (e, item) => {
    setModifyModal(true);
    setPartGroupData({
      id: item?.id,
      ecommerce_name: item?.ecommerce_name,
      token: item?.token,
      allow_reserve: item?.allow_reserve,
      allow_sales: item?.allow_sales,
      allow_refund: item?.allow_refund,
      price_value: item?.price_value,
      percentage: item?.percentage,
      percentage_type: item?.percentage_type,
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart };

    if (params.record_show_type === 1) {
      let UpdateData = {
        id: delpart,
      };

      restoreCompanyEcommerceHash(UpdateData)
        .then((response) => {
          let data = { ...params };

          fetchPartLocation(data);
          toast.success(response.data.message);
          setDelPart("");
          setDelModal(false);
          setIsDelButtonLoad(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      deleteCompanyEcommerceHash(data)
        .then((response) => {
          let data = { ...params };

          fetchPartLocation(data);
          toast.success(response.data.message);
          setDelPart("");
          setDelModal(false);
          setIsDelButtonLoad(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleCompanyEcommerce = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!partGroupData.ecommerce_name) {
      errorObj.ecommerce_name = `name is required.`;
      error = true;
    }

    setErrors(errorObj);
    if (error) return;

    const generateToken = () => {
      return [...Array(34)].map(() => Math.random().toString(36)[2]).join("");
    };

    const token = generateToken();

    setIsModifyButtonLoad(true);
    let data = {
      name: partGroupData.ecommerce_name,
      token: token,
      allow_reserve: partGroupData?.allow_reserve,
      allow_sales: partGroupData?.allow_sales,
      allow_refund: partGroupData?.allow_refund,
      price_value: partGroupData?.price_value,
      percentage: partGroupData?.percentage,
      percentage_type: partGroupData?.percentage_type,
    };

    let updateData = {
      id: partGroupData.id,
      name: partGroupData.ecommerce_name,
      token: partGroupData?.token,
      allow_reserve: partGroupData?.allow_reserve,
      allow_sales: partGroupData?.allow_sales,
      allow_refund: partGroupData?.allow_refund,
      price_value: partGroupData?.price_value,
      percentage: partGroupData?.percentage,
      percentage_type: partGroupData?.percentage_type,
    };

    if (partGroupData?.id) {
      updateCompanyEcommerceHash(updateData)
        .then((response) => {
          toast.dismiss();
          toast.success(response.data.message);
          let data = { ...params };
          fetchPartLocation(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setPartGroupData({
            id: "",
            ecommerce_name: "",
            token: "",
            allow_reserve: "",
            allow_sales: "",
            allow_refund: "",
            price_value: "",
            percentage: "",
            percentage_type: "",
          });
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createCompanyEcommerceHash(data)
        .then((response) => {
          toast.dismiss();
          toast.success(response.data.message);
          let data = { ...params };
          fetchPartLocation(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setPartGroupData({
            id: "",
            ecommerce_name: "",
            token: "",
            allow_reserve: "",
            allow_sales: "",
            allow_refund: "",
            price_value: "",
            percentage: "",
            percentage_type: "",
          });
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <h1 className="page-title">Part Type</h1> */}
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <div className="custom-flex">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            value={params.search}
                            onChange={(e) => handleParams(e, "search")}
                            placeholder="Search"
                          ></input>
                        </div>

                        <div className="col-md-4">
                          <select
                            className="form-select"
                            type="select"
                            value={params.record_show_type}
                            onChange={(e) => {
                              handleParams(e, "record_show_type");
                            }}
                          >
                            {recordList?.map((item) => (
                              <option key={item.value} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="card-title m-0 float-right d-flex">
                      {/* {RolePermission?.findIndex(
                          (e) => e.permission_name === "add_part_type"
                        ) > -1 && ( */}
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleAddModal}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>
                      {/* )} */}
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table-striped table-hover">
                        <thead>
                          <tr>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("ecommerce_name")}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("token")}
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "0%" }}
                            >
                              {t("action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {partGroupList?.map((item, index) => (
                            <tr key={item.id}>
                              {" "}
                              <td>{item?.ecommerce_name}</td>
                              <td>{item?.token}</td>
                              <td>
                                <div className="d-flex">
                                  <Dropdown
                                    className="iconDropdown"
                                    onToggle={(isOpen) => {
                                      if (isOpen) {
                                        // This logic runs when the dropdown is opened
                                        const tableResponsive =
                                          document.querySelector(
                                            ".table-responsive"
                                          );
                                        if (window.innerWidth <= 767) {
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "auto !important";
                                            tableResponsive.style.overflowY =
                                              "auto !important";
                                          }
                                        } else {
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "inherit !important";
                                            tableResponsive.style.overflowY =
                                              "inherit !important";
                                          }
                                        }
                                      }
                                    }}
                                  >
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                      className="iconToggle"
                                    >
                                      <i className="bi bi-three-dots-vertical"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      {params.record_show_type === 0 && (
                                        <Dropdown.Item
                                          href="#/action-1"
                                          className="d-flex"
                                          onClick={(e) =>
                                            onEditPartType(e, item)
                                          }
                                        >
                                          <div className="edit-btn">
                                            <i className="bi bi-pencil"></i>
                                          </div>
                                          <span>{t("edit")}</span>
                                        </Dropdown.Item>
                                      )}

                                      <Dropdown.Item
                                        href="#/action-2"
                                        className="d-flex"
                                      >
                                        <>
                                          {params.record_show_type === 1 ? (
                                            <>
                                              <div className="trash-btn">
                                                <a
                                                  className="delete-btn"
                                                  href="#"
                                                  onClick={(e) =>
                                                    onDeleteModalOpen(e, item)
                                                  }
                                                >
                                                  <i className="bi bi-arrow-clockwise"></i>
                                                </a>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="trash-btn">
                                              <a
                                                className="delete-btn"
                                                href="#"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </a>
                                            </div>
                                          )}
                                        </>

                                        {params.record_show_type === 1 ? (
                                          <span
                                            onClick={(e) =>
                                              onDeleteModalOpen(e, item)
                                            }
                                          >
                                            Restore
                                          </span>
                                        ) : (
                                          <span
                                            onClick={(e) =>
                                              onDeleteModalOpen(e, item)
                                            }
                                          >
                                            Delete
                                          </span>
                                        )}
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {partGroupList && partGroupList?.length === 0 && (
                            <tr>
                              <td colSpan={4} className="text-center">
                                {t("no_record_found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer card-footer-part clearfix">
            <div className="pagination pagination-sm m-0 float-right">
              <ReactPaginate
                previousLabel={<i className="bi bi-chevron-double-left"></i>}
                nextLabel={<i className="bi bi-chevron-double-right"></i>}
                breakLabel={"..."}
                pageCount={Math.ceil(totalRecords / params.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handleParams(e, "pagination")}
                forcePage={params.page - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>
          {params.record_show_type === 1
            ? "Restore Ecommerce Hash"
            : "Delete Ecommerce Hash"}
        </ModalHeader>
        <ModalBody>
          <p className="mb-0">
            {params.record_show_type === 1
              ? t("are_you_sure_you_want_to_restore_this_e_commerce_products")
              : t("are_you_sure_you_want_to_delete_this_e_commerce_products")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && params.record_show_type === 1 ? (
            <>
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                onClick={onDestroyPartType}
              >
                Restore <i className="bi bi-arrow-repeat"></i>
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                onClick={onDestroyPartType}
              >
                Delete <i className="bi bi-trash3"></i>
              </button>
            </>
          )}

          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal}>
        <ModalHeader className="modal-custom-header">
          {t("company_ecommerce_hash")}
        </ModalHeader>
        <Form method={`post`} onSubmit={handleCompanyEcommerce}>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("ecommerce_name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={partGroupData.ecommerce_name}
                        onChange={(e) => {
                          setPartGroupData({
                            ...partGroupData,
                            ecommerce_name: e.target.value,
                          });
                        }}
                        name={`ecommerce_name`}
                        maxLength={50}
                        placeholder="Ecommerce Name"
                      />
                    </div>
                    {errors.ecommerce_name && (
                      <span className="input-error">
                        {errors.ecommerce_name}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("allow_reserve")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={partGroupData?.allow_reserve === 1}
                          onChange={handleCheckboxChangeAllowReserve}
                        />
                        <label className="form-check-label pl-2">
                          {t("allow_reserve")}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("allow_sales")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={partGroupData?.allow_sales === 1}
                          onChange={handleCheckboxChangeAllowSales}
                        />
                        <label className="form-check-label pl-2">
                          {t("allow_sales")}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("allow_refund")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={partGroupData?.allow_refund === 1}
                          onChange={handleCheckboxChangeAllowRefund}
                        />
                        <label className="form-check-label pl-2">
                          {t("allow_refund")}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <div className="input-div">
                  <Label className="col-form-label ml-2 Label-my">
                    {t("price_value")}{" "}
                  </Label>
                  <Select
                    className="my-select-v"
                    options={PriceTypeList}
                    value={PriceTypeList.find(
                      (item) => item.value == partGroupData.price_value
                    )}
                    onChange={(selectedOption) => {
                      setPartGroupData({
                        ...partGroupData,
                        price_value: selectedOption ? selectedOption.value : "",
                      });
                    }}
                    isSearchable={true}
                    isClearable={true}
                    placeholder={"Select Price Value"}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("percentage")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        name="percentage"
                        min="0"
                        value={partGroupData.percentage}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || /^\d*\.?\d*$/.test(value)) {
                            setPartGroupData({
                              ...partGroupData,
                              percentage: value,
                            });
                          }
                        }}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Percentage"
                      />
                    </div>
                    {errors.percentage && (
                      <span className="input-error">{errors.percentage}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <div className="input-div">
                  <Label className="col-form-label ml-2 Label-my">
                    {t("percentage_type")}{" "}
                  </Label>
                  <Select
                    className="my-select-v"
                    options={percentageTypeList}
                    value={percentageTypeList.find(
                      (item) => item.value == partGroupData.percentage_type
                    )}
                    onChange={(selectedOption) => {
                      setPartGroupData({
                        ...partGroupData,
                        percentage_type: selectedOption
                          ? selectedOption.value
                          : "",
                      });
                    }}
                    isSearchable={true}
                    isClearable={true}
                    placeholder={"Select Percentage Type"}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
              </div>

            
            </div>
          </ModalBody>
          <ModalFooter className="pb-5">
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default CompanyEcommerceHash;
